import { useContext } from 'react';

import { NavVisibilityContext } from './NavVisibilityContext';

export const useNavVisibility = () => {
    const ctx = useContext(NavVisibilityContext);
    if (!ctx) {
        throw new Error(
            'useNavVisibility must be used within NavVisibilityProvider'
        );
    }
    return ctx;
};
